import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, switchMap, throwError } from 'rxjs';

import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable()
export class RequestInterceptorService implements HttpInterceptor {
	private readonly valleLabUrl: string = environment.urlApiValleLab;

	constructor(
		private readonly ls: LocalStorageService,
		private readonly authService: AuthService,
		private readonly router: Router,
	) {}

	intercept(
		req: HttpRequest<any>,
		next: HttpHandler,
	): Observable<HttpEvent<any>> {
		if (req.url.includes('demosviaalavida')) {
			return this.handleDemosViaAlavidaRequest(req, next);
		}

		if (req.url.includes('@valleLabApi')) {
			return this.handleValleLabApiRequest(req, next);
		}

		if (req.url.includes('auth') && !req.url.includes('logout')) {
			return next.handle(req);
		}

		return this.handleDefaultRequest(req, next);
	}

	private handleDemosViaAlavidaRequest(
		req: HttpRequest<any>,
		next: HttpHandler,
	): Observable<HttpEvent<any>> {
		const tokenSegVial = localStorage.getItem('tokenSegVial');
		if (tokenSegVial) {
			const reqClone = req.clone({
				setHeaders: {
					authorization: `Bearer ${JSON.parse(tokenSegVial)}`,
				},
			});
			return next.handle(reqClone);
		}
		return next.handle(req);
	}

	private handleValleLabApiRequest(
		req: HttpRequest<any>,
		next: HttpHandler,
	): Observable<HttpEvent<any>> {
		const url = req.url.replace('@valleLabApi', this.valleLabUrl);
		const token = this.ls.getItem('tokenValleLab');

		const reqClone = req.clone({
			url: url,
			setHeaders: token ? { authorization: `Bearer ${token}` } : {},
		});

		return next
			.handle(reqClone)
			.pipe(catchError((error) => this.handleAuthError(error, true)));
	}

	private handleDefaultRequest(
		req: HttpRequest<any>,
		next: HttpHandler,
	): Observable<HttpEvent<any>> {
		const reqClone = req.clone({
			setHeaders: {
				Authorization: `Bearer ${this.ls.getItem('bearer')}`,
			},
		});

		return next
			.handle(reqClone)
			.pipe(catchError((error) => this.handleAuthError(error, false)));
	}

	private handleAuthError(
		error: HttpErrorResponse,
		isValleLab: boolean,
	): Observable<never> {
		if (error.status === 401) {
			const refreshToken$ = isValleLab
				? this.authService.valleLabRefreshToken()
				: this.authService.refreshToken();

			return refreshToken$.pipe(
				catchError(() => {
					this.authService.clearSession();
					window.location.href =
						'/login?redirect=' + encodeURIComponent(this.router.url);
					return throwError(() => error);
				}),
				switchMap(() => {
					window.location.reload();
					return throwError(() => error);
				}),
			);
		}

		return throwError(() => error);
	}
}
